import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import StickyCallButton from "./components/StickyCallButton";
import Home from "./pages/Home";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

const Layout = ({ children, hideChrome }) => (
  <>
    {!hideChrome && <Navbar />}
    <main>{children}</main>
    {!hideChrome && <Footer />}
    {!hideChrome && <StickyCallButton />}
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#0B132B",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "0",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/faq" element={<Layout><FAQ /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
